var _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 98,
    viewBox: "0 0 94 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3251 19.8712L30.5646 26.6641C21.9058 29.1395 18.3144 35.7758 20.6343 45.0133L26.9942 70.338C29.3141 79.5755 35.5344 83.4067 44.1931 80.9313L67.9537 74.1385C76.6124 71.6631 80.1812 65.0332 77.8613 55.7958L71.5014 30.471C69.1815 21.2335 62.9839 17.3958 54.3251 19.8712Z",
    fill: "url(#paint0_linear_9259_31611)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9259_31611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.0334 53.0594L61.7185 35.6207C60.1534 29.2952 56.2363 26.459 51.0858 27.9097L33.6416 32.8231C28.4067 34.2976 26.3796 38.8081 27.9447 45.1336L32.2595 62.5723C33.8499 68.9997 37.6737 71.751 42.9086 70.2765L60.3528 65.3631C65.5033 63.9124 67.6237 59.4868 66.0334 53.0594Z",
    fill: "#8237FF",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_9259_31611)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_9259_31611",
    maskUnits: "userSpaceOnUse",
    x: 35.3438,
    y: 30.8184,
    width: 55,
    height: 59,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 35.3438,
    y: 30.8184,
    width: 55,
    height: 59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9819 31.8184H50.3855C41.4222 31.8184 36.3438 37.2368 36.3438 46.8001V73.0182C36.3438 82.5816 41.4222 88 50.3855 88H74.9819C83.9453 88 89.0003 82.5816 89.0003 73.0182V46.8001C89.0003 37.2368 83.9453 31.8184 74.9819 31.8184Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.9819 31.8184H50.3855C41.4222 31.8184 36.3438 37.2368 36.3438 46.8001V73.0182C36.3438 82.5816 41.4222 88 50.3855 88H74.9819C83.9453 88 89.0003 82.5816 89.0003 73.0182V46.8001C89.0003 37.2368 83.9453 31.8184 74.9819 31.8184Z",
    fill: "#BA90FF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9819 32.8184C75.5342 32.8184 75.9819 32.3706 75.9819 31.8184C75.9819 31.2661 75.5342 30.8184 74.9819 30.8184V32.8184ZM74.9819 30.8184C74.4297 30.8184 73.9819 31.2661 73.9819 31.8184C73.9819 32.3706 74.4297 32.8184 74.9819 32.8184V30.8184ZM74.9819 30.8184H50.3855V32.8184H74.9819V30.8184ZM50.3855 30.8184C45.6994 30.8184 41.897 32.2403 39.2738 35.0391C36.6595 37.8284 35.3438 41.8495 35.3438 46.8001H37.3438C37.3438 42.1874 38.5672 38.7176 40.733 36.4068C42.8898 34.1056 46.1083 32.8184 50.3855 32.8184V30.8184ZM35.3438 46.8001V73.0182H37.3438V46.8001H35.3438ZM35.3438 73.0182C35.3438 77.9688 36.6595 81.9899 39.2738 84.7792C41.897 87.578 45.6994 89 50.3855 89V87C46.1083 87 42.8898 85.7127 40.733 83.4115C38.5672 81.1007 37.3438 77.6309 37.3438 73.0182H35.3438ZM50.3855 89H74.9819V87H50.3855V89ZM74.9819 89C79.6682 89 83.4653 87.5779 86.0828 84.7783C88.691 81.9887 90.0003 77.9677 90.0003 73.0182H88.0003C88.0003 77.6321 86.782 81.102 84.6219 83.4124C82.4711 85.7128 79.259 87 74.9819 87V89ZM90.0003 73.0182V46.8001H88.0003V73.0182H90.0003ZM90.0003 46.8001C90.0003 41.8506 88.691 37.8297 86.0828 35.04C83.4653 32.2404 79.6682 30.8184 74.9819 30.8184V32.8184C79.259 32.8184 82.4711 34.1055 84.6219 36.4059C86.782 38.7163 88.0003 42.1862 88.0003 46.8001H90.0003Z",
    fill: "url(#paint1_linear_9259_31611)",
    mask: "url(#path-3-outside-1_9259_31611)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_9259_31611)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_9259_31611",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7658 43.3047C61.5723 43.3047 60.5893 44.3534 60.5893 45.6518V74.1671C60.5893 75.4406 61.5723 76.4893 62.7658 76.4893C63.9827 76.4893 64.9657 75.4406 64.9657 74.1671V45.6518C64.9657 44.3534 63.9827 43.3047 62.7658 43.3047ZM50.4792 52.5193C49.2857 52.5193 48.3027 53.568 48.3027 54.8664V74.1679C48.3027 75.4414 49.2857 76.4901 50.4792 76.4901C51.6962 76.4901 52.6791 75.4414 52.6791 74.1679V54.8664C52.6791 53.568 51.6962 52.5193 50.4792 52.5193ZM72.6889 65.0538C72.6889 63.7554 73.6718 62.7067 74.8888 62.7067C76.0823 62.7067 77.0653 63.7554 77.0653 65.0538V74.1677C77.0653 75.4412 76.0823 76.4899 74.8654 76.4899C73.6718 76.4899 72.6889 75.4412 72.6889 74.1677V65.0538Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7658 43.3047C61.5723 43.3047 60.5893 44.3534 60.5893 45.6518V74.1671C60.5893 75.4406 61.5723 76.4893 62.7658 76.4893C63.9827 76.4893 64.9657 75.4406 64.9657 74.1671V45.6518C64.9657 44.3534 63.9827 43.3047 62.7658 43.3047ZM50.4792 52.5193C49.2857 52.5193 48.3027 53.568 48.3027 54.8664V74.1679C48.3027 75.4414 49.2857 76.4901 50.4792 76.4901C51.6962 76.4901 52.6791 75.4414 52.6791 74.1679V54.8664C52.6791 53.568 51.6962 52.5193 50.4792 52.5193ZM72.6889 65.0538C72.6889 63.7554 73.6718 62.7067 74.8888 62.7067C76.0823 62.7067 77.0653 63.7554 77.0653 65.0538V74.1677C77.0653 75.4412 76.0823 76.4899 74.8654 76.4899C73.6718 76.4899 72.6889 75.4412 72.6889 74.1677V65.0538Z",
    fill: "url(#paint2_linear_9259_31611)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9893 45.6518C60.9893 44.5466 61.8199 43.7047 62.7658 43.7047V42.9047C61.3246 42.9047 60.1893 44.1602 60.1893 45.6518H60.9893ZM60.9893 74.1671V45.6518H60.1893V74.1671H60.9893ZM62.7658 76.0893C61.8172 76.0893 60.9893 75.2445 60.9893 74.1671H60.1893C60.1893 75.6367 61.3273 76.8893 62.7658 76.8893V76.0893ZM64.5657 74.1671C64.5657 75.2416 63.7405 76.0893 62.7658 76.0893V76.8893C64.225 76.8893 65.3657 75.6395 65.3657 74.1671H64.5657ZM64.5657 45.6518V74.1671H65.3657V45.6518H64.5657ZM62.7658 43.7047C63.7378 43.7047 64.5657 44.5495 64.5657 45.6518H65.3657C65.3657 44.1573 64.2277 42.9047 62.7658 42.9047V43.7047ZM48.7027 54.8664C48.7027 53.7612 49.5333 52.9193 50.4792 52.9193V52.1193C49.038 52.1193 47.9027 53.3748 47.9027 54.8664H48.7027ZM48.7027 74.1679V54.8664H47.9027V74.1679H48.7027ZM50.4792 76.0901C49.5306 76.0901 48.7027 75.2453 48.7027 74.1679H47.9027C47.9027 75.6375 49.0407 76.8901 50.4792 76.8901V76.0901ZM52.2791 74.1679C52.2791 75.2424 51.4539 76.0901 50.4792 76.0901V76.8901C51.9384 76.8901 53.0791 75.6404 53.0791 74.1679H52.2791ZM52.2791 54.8664V74.1679H53.0791V54.8664H52.2791ZM50.4792 52.9193C51.4512 52.9193 52.2791 53.7641 52.2791 54.8664H53.0791C53.0791 53.3719 51.9411 52.1193 50.4792 52.1193V52.9193ZM74.8888 62.3067C73.4269 62.3067 72.2889 63.5593 72.2889 65.0538H73.0889C73.0889 63.9515 73.9168 63.1067 74.8888 63.1067V62.3067ZM77.4653 65.0538C77.4653 63.5622 76.33 62.3067 74.8888 62.3067V63.1067C75.8347 63.1067 76.6653 63.9486 76.6653 65.0538H77.4653ZM77.4653 74.1677V65.0538H76.6653V74.1677H77.4653ZM74.8654 76.8899C76.3246 76.8899 77.4653 75.6401 77.4653 74.1677H76.6653C76.6653 75.2422 75.8401 76.0899 74.8654 76.0899V76.8899ZM72.2889 74.1677C72.2889 75.6373 73.4269 76.8899 74.8654 76.8899V76.0899C73.9168 76.0899 73.0889 75.2451 73.0889 74.1677H72.2889ZM72.2889 65.0538V74.1677H73.0889V65.0538H72.2889Z",
    fill: "url(#paint3_linear_9259_31611)",
    mask: "url(#path-5-inside-2_9259_31611)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9259_31611",
    x: 0.429688,
    y: 0.537109,
    width: 93.1211,
    height: 97.1279,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5,
    result: "effect1_foregroundBlur_9259_31611"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_9259_31611",
    x: 11.3438,
    y: 6.81836,
    width: 102.656,
    height: 106.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9259_31611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9259_31611",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_9259_31611",
    x: 33.3027,
    y: 28.3047,
    width: 58.7617,
    height: 63.1855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9259_31611"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.577356 0 0 0 0 0.359375 0 0 0 0 0.9375 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_9259_31611",
    result: "effect2_dropShadow_9259_31611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9259_31611",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9259_31611",
    x1: 42.4335,
    y1: 23.2709,
    x2: 57.8054,
    y2: 77.0398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743BBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9259_31611",
    x1: 44.7258,
    y1: 38.3636,
    x2: 80.983,
    y2: 80.4514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9259_31611",
    x1: 75.026,
    y1: 49.2973,
    x2: 42.9788,
    y2: 50.2029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9259_31611",
    x1: 52.8813,
    y1: 47.1708,
    x2: 74.482,
    y2: 70.3582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.f86de9205ad2a75fb6fba9290d903487.svg";
export { ForwardRef as ReactComponent };